import { render, staticRenderFns } from "./DrawRule.vue?vue&type=template&id=b39ade2a&scoped=true&"
import script from "./DrawRule.vue?vue&type=script&lang=js&"
export * from "./DrawRule.vue?vue&type=script&lang=js&"
import style0 from "./DrawRule.vue?vue&type=style&index=0&id=b39ade2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39ade2a",
  null
  
)

export default component.exports